import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {FormattedDate, FormattedMessage, FormattedNumber} from 'react-intl';
import CurrencyNumber from '../../cmp/CurrencyNumber';
import {connect, useSelector} from 'react-redux';
import {get} from '../../../api';
import Big from 'big.js';
import Checkbox from '../../cmp/form/Checkbox';
import uniq from 'lodash.uniq';
import Skeleton from 'react-loading-skeleton';
import BackButton from '../../cmp/BackButton';
import FormattedOption from '../../cmp/form/FormattedOption';
import BootStrapTable from '../../cmp/BootStrapTable';
import {ExternalLinkIcon} from '../../../icons/Icons';
import {buildRefLink} from '@goaffpro/aff-client-commons/functions';
import Input from '../../cmp/form/Input';
import useDebounce from '../../cmp/hooks/useDebounce';
import uniqby from 'lodash.uniqby';
import dayjs from 'dayjs';

export default function CompPlanTeamExplorer({loading, timePeriodKey, data}) {
  const affiliate_id = useMemo(()=>{
    return data?.result?.affiliate_id;
  },[data])
  const [level, setLevel] = useState('')
  const affiliates = useMemo(()=>{
    if(data && data.result && data.result.team){
      if(level){
        return data.result.team.filter((i)=>Number(i.level) <= Number(level))
      }else{
        return data.result.team;
      }
    }else{
      return [];
    }
  },[data, level])
  const [startDate, endDate] = useMemo(()=>{
      const [interval, month, year] = timePeriodKey.split("-");
      const p = dayjs().month(month).year(year)
      return [p.startOf('month'), p.endOf('month')]
  },[timePeriodKey])
  const num_levels = useMemo(()=>{
    return uniq(data?.result?.team.map((i)=>i.level)).length
  },[data])

  if(!data || !data.result) return null;
  return (<>
        <div className={"py-2"}>
          <select className="form-control" value={level} onChange={(e)=>setLevel(e.target.value)}>
            <FormattedOption value={""}>Entire team</FormattedOption>
            {
              [...Array(num_levels)].map((item, index)=>{
                const l = Number(index) + 1
                return <FormattedMessage id={"Level"} key={String(l)}>
                  {(message) => <option value={l}>{message} {l}</option>}
                </FormattedMessage>
              })
            }
          </select>
        </div>
        {/*
        <div className="my-4">
          {
            loading ? <Skeleton count={4}/> :
                <RenderStatsCard affiliates={affiliates}/>
          }
        </div>
        */}
        <div className="my-4">
          {
            loading ? <Skeleton count={20}/> :
                <RenderAffiliateSales
                    networkExplorerConfiguration={data.networkExplorerConfiguration}
                    startDate={startDate}
                    endDate={endDate}
                    affiliate_id={affiliate_id} affiliates={affiliates}/>
          }
        </div>

      </>
  );
}

const colorsArray = [
  "#1abc9c",
  "#2ecc71",
  "#3498db",
  "#9b59b6",
  "#34495e",
  "#16a085",
  "#27ae60",
  "#2980b9",
  "#8e44ad",
  "#2c3e50"
]

function RenderStatsCard({ affiliates }){
  if(!affiliates) return null;
  const levels = uniq(affiliates.map(({level})=>level));
  const revenue = Number(affiliates.reduce((acc, cur)=> acc.plus(cur.revenue || 0), Big(0)).toFixed(2))
  const numOrders = Number(affiliates.reduce((acc, cur)=> acc.plus(cur.numOrders || 0), Big(0)).toFixed(2))
  const earnings = Number(affiliates.reduce((acc, cur)=>acc.plus(cur.earnings || 0), Big(0)).toFixed(2))
  return <>
    <>
      <h4><FormattedMessage id={"Summary"}/></h4>
      <div className="row">
        <CardItem label={"Number of sales"} value={numOrders}/>
        <CardItem label={"Total sale volume"} value={<CurrencyNumber value={revenue} />}/>
        <div className="d-none">
          <CardItem label={"Total earnings"} value={<CurrencyNumber value={earnings} />}/>
        </div>
      </div>
    </>
    {
      levels.length > 1 ? <ul className={"list-group mt-4"}>{
        levels.map((item) => <RenderLevelSummary key={String(item)} affiliates={affiliates} level={item}/>)
      }
      </ul> : null
    }
  </>
}

const columns = [
  {
    title:'Date',
    dataIndex:'created_at',
    render:(value)=>{
      return <FormattedDate value={new Date(value)} year={"numeric"} day={"numeric"} month={"short"} />
    }
  },
  {
    title:'Order #',
    dataIndex:'number'
  },
  {
    title:'Amount',
    dataIndex: 'subtotal',
    type:'number',
    render:(value)=><CurrencyNumber value={value} />
  }
]




function RenderLevelSummary({affiliates, level}){
  const data = affiliates.filter((item)=>item.level === level);
  const revenue = Number(data.reduce((acc, cur)=> acc.plus(cur.revenue), Big(0)).toFixed(0))
  const numOrders = Number(data.reduce((acc, cur)=> acc.plus(cur.numOrders), Big(0)).toFixed(0))
  const earnings = Number(data.reduce((acc, cur)=> acc.plus(cur.earnings), Big(0)).toFixed(2))

  return <li className={'list-group-item'}>
    <div className="row">
      <div className="col-md-4">
        <div>Level {level}</div>
      </div>
      <div className="col-md-4 text-center">
        {
          numOrders > 0 ?
              <div>{numOrders} orders</div> : "-"
        }
      </div>
      <div className="col-md-4 text-right">
        {
          revenue > 0 ?
              <CurrencyNumber value={revenue}/> : "-"
        }
        {
          earnings > 0 ?<small className={"text-muted pl-2"}>(<CurrencyNumber value={earnings} />)</small> : null
        }
      </div>
    </div>

  </li>
}

function CardItem({value, label}){
  return <div className="col-md-6">
    <div className="card">
      <div className="card-body">
        <h3>{value}</h3>
        <small><FormattedMessage id={label} /></small>
      </div>
    </div>
  </div>
}

function ShowDownlineSales({affiliate_id, startDate, endDate}){
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(()=>{
    if(affiliate_id){
      setLoading(true)
      get('/mlm/downline_orders',{
        affiliate_id,
        startDate,
        endDate,
      }).then((data)=>{
        setLoading(false)
        setData(data.orders)
      })
    }
  },[affiliate_id, endDate, startDate])
  return <BootStrapTable dataSource={data} loading={loading} columns={columns} />

}

function RenderTree({affiliates, parent_id, startDate, endDate}){
  const [visible, setVisible] = useState({})
  const site_id = useSelector((state)=>state.settings.site_id)
  const website = useSelector((state)=>state.settings.website)
  const toggleVisibility = useCallback((affiliate_id)=>{
    return (e)=>{
      if(e){
        e.stopPropagation();
      }
//            if(site_id == 155413) {
      setVisible((v) => {
        return {
          ...v,
          [affiliate_id]: !v[affiliate_id]
        }
      })
//            }
    }
  },[site_id])
  const data = useMemo(()=>{
    return affiliates.filter((item)=>Number(item.parent_id) === Number(parent_id))
  },[affiliates])
  if(data.length === 0) {
    return null
  }
  const level = data[0].level;
  const color = level > 1 ? colorsArray[level-1] : undefined;
  return <ul className={`list-group ${level > 1 ? "mt-2" : ''}`}>
    {
      data.map((aff)=>{
        const {name, email, ref_code, profile_photo, affiliate_id, extraInfoHtml} = aff;
        return <li className="list-group-item" onClick={toggleVisibility(affiliate_id)}
                   key={String(affiliate_id)}>
          <div className="row">
            <div className="col d-flex align-items-center">
              <div className={"mr-2"}>
                {
                  profile_photo ?
                      <img src={profile_photo}
                           className={"shadow-sm"}
                           style={{
                             borderRadius: 32,
                             width: 48,
                             height: 48,
                             overflow: 'hidden',
                             objectFit: 'cover'
                           }}/> : <div
                          className={"shadow-sm d-flex align-items-center justify-content-center"}
                          style={{
                            fontSize:20,
                            fontWeight:300,
                            backgroundColor:'#34495e',
                            color:'#efefef',
                            textTransform:"uppercase",
                            borderRadius: 32,
                            width: 48,
                            height: 48,
                            overflow: 'hidden',
                            objectFit: 'cover'
                          }}>{name.substring(0, 2)}</div>
                }
              </div>
              <div>
                <div title={'Level '+level} style={{color}}>{name} {ref_code ? <a className="ml-1" style={{fontSize:12}} href={buildRefLink(ref_code, website)}><ExternalLinkIcon /></a> : null}</div>
                <small className={"text-muted downline_email"}><a rel={"noreferrer noopener"} href={"mailto:"+email} target={"_blank"}>{email}</a></small>
              </div>
            </div>
                  <div className="col text-right" dangerouslySetInnerHTML={{__html: extraInfoHtml}}></div>
          </div>
          {
            visible[affiliate_id] ? <div className={"py-2"}>
                  <ShowDownlineSales
                      startDate={startDate}
                      endDate={endDate}
                      affiliate_id={affiliate_id} />
                </div>
                : null
          }
          <RenderTree
              startDate={startDate}
              endDate={endDate}
              parent_id={affiliate_id} affiliates={affiliates} />
        </li>
      })
    }
  </ul>
}

function getUplines(data, parent_id){
  if(!parent_id) return []
  const parent = data.find((i)=>i.affiliate_id == parent_id)
  if(!parent) return [];
  return [parent, ...getUplines(data, parent.parent_id)]
}

function RenderAffiliateSales({affiliates, startDate, networkExplorerConfiguration, endDate, affiliate_id}){
  const [showActive, setShowActive] = useState(true);
  const [keyword, setKeyword] = useState('')
  const _keyword = useDebounce(keyword, 300);
  const filteredAffiliates = useMemo(()=>{
    let a = affiliates;
    if(_keyword || showActive) {
      if (_keyword) {
        const k = _keyword.toLowerCase()
        a = a.filter(
            ({name, email}) => name.toLowerCase().match(k) ||
                email.toLowerCase().match(k))
      }
      if (showActive) {
        a = a.filter((a)=> a[networkExplorerConfiguration.isActiveParameter])
      }
      // make sure their top heirarchies is also preserved
      for (let {parent_id, affiliate_id} of a) {
        if (!a.find((i) => i.affiliate_id == parent_id)) {
          // we need to add the top lines
          const parents = getUplines(affiliates, parent_id)
          for (let p of parents) {
            a.push(p);
          }
        }
      }
      return uniqby(a, ({affiliate_id})=>affiliate_id).sort((a, b)=>b.revenue+b.numOrders - a.revenue+a.numOrders);
    }else {
      return affiliates.sort((a, b)=>b.revenue+b.numOrders - a.revenue+a.numOrders)
    }
  },[_keyword, affiliates, showActive])
  return <>
    <h5>Details</h5>
    <div className="row align-items-center">
      <div className="col-md-6 mb-2">
        <Input value={keyword} onChange={setKeyword} type={"search"} placeholder={"Search..."} />
      </div>
      <div className="col-md-6 mb-2 text-right">
        <Checkbox onChange={(e)=>setShowActive(e.target.checked)} label={<FormattedMessage id={"Show active affiliates"} />} checked={showActive} />
      </div>
    </div>
    <RenderTree  startDate={startDate} endDate={endDate}
                 propertiesToDisplay={networkExplorerConfiguration.propertiesToDisplay}
                 affiliates={filteredAffiliates} parent_id={affiliate_id}/>
  </>
}
